import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'An author added a sub-page to a collection share link',
  name: 'subpage_added',
  params: [
    {
      description: 'The name the new sub-page was created with',
      name: 'page_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
